<div class="container">
    <div class="ui-g">
        <div class="ui-g-12">
            <div class="mat-card">
                <h1>Upload</h1>
                <div class="d-flex">
                    <input
                        type="file"
                        class="file-input"
                        [accept]="'.csv'"
                        (change)="onFileSelected($event)"
                        #fileUpload
                    />
                    <div class="file-upload" (click)="fileUpload.click()">
                        {{ fileName || 'Select file' }}
                        <button mat-mini-fab color="primary" class="upload-btn mx-3">
                            <mat-icon>attach_file</mat-icon>
                        </button>
                    </div>
                    <button class="btn primary" (click)="uploadFile()">Upload</button>
                </div>
            </div>
        </div>
    </div>
</div>
